import { render, staticRenderFns } from "./BuilderTranscription.vue?vue&type=template&id=45bc8636&scoped=true&"
import script from "./BuilderTranscription.vue?vue&type=script&lang=js&"
export * from "./BuilderTranscription.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTranscription.vue?vue&type=style&index=0&id=45bc8636&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc8636",
  null
  
)

export default component.exports